<div class="container-scroller">
    <app-topnav class="fixed-top"></app-topnav>
    <app-sportsnav *ngIf="!router.url.includes('/casino-detail')"></app-sportsnav>
    <app-upcoming *ngIf="!router.url.includes('/reports') && !router.url.includes('/stake-setting') && !router.url.includes('/casino-detail')"></app-upcoming>
    <div class="container-fluid page-body-wrapper">
        <app-sidebar *ngIf="!router.url.includes('/casino-detail')"></app-sidebar>
        <div class="main-panel" [ngClass]="(router.url.includes('/casino-detail'))?'main-panel-full':''">
            <div class="content-wrapper">
                <router-outlet></router-outlet>
            </div><!-- content-wrapper ends -->
        </div><!-- main-panel ends -->
    </div> <!-- page-body-wrapper ends -->
</div><!-- container-scroller -->

<app-footer *ngIf="!router.url.includes('/casino-detail')"></app-footer>


